import routes from './routes';
import general from './routes/general';
import auth from './routes/auth';
import user from './routes/user';
import bibleQuote from './routes/bible-quote';
import dailyInspiration from './routes/daily-inspiration';
import conversationStarter from './routes/conversation-starter';
import conversationStarterCategory from './routes/conversation-starter-category';
import quiz from './routes/quiz';
import article from './routes/article';
import userQuiz from './routes/user-quiz';
import dateNight from './routes/date-night';
import assessmentQuestions from './routes/assessment-questions';
import reward from './routes/reward';
import donation from './routes/donation';
import appVersion from './routes/app-version';

const routesList = [
    ...general,
    ...auth,
    ...user,
    ...dailyInspiration,
    ...bibleQuote,
    ...dateNight,
    ...conversationStarter,
    ...conversationStarterCategory,
    ...quiz,
    ...article,
    ...userQuiz,
    ...assessmentQuestions,
    ...reward,
    ...donation,
    ...appVersion,
];

export { routesList };
export { routes };
export { default as history } from './history';
